<label class="pb-1 text-sm font-bold" [for]="formControlName"
    >{{ label }}
    @if (required) {
        <span class="text-red">*</span>
    }
</label>
<div class="flex items-center gap-2 rounded-md border border-grey-150">
    <ng-content></ng-content>
    <input
        [id]="formControlName"
        [placeholder]="placeholder"
        [formControl]="control"
        class="w-full rounded-md border-2 p-2 text-black outline-none transition placeholder:text-grey-500 focus:border-2 disabled:cursor-not-allowed disabled:opacity-70"
        [type]="type" />
</div>
@if (control.hasError('required') && control.touched) {
    <p class="text-sm font-medium text-red">{{ label }} is required</p>
}
